/* SORIVO — About Us story engine. Runs only where [data-ab] exists (the Über uns page).
   Progressive enhancement: without this file (or with reduced motion) the page is a static editorial story. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ab]');
  if (!root || root.__abInit) return;
  root.__abInit = true;
  window.__abReady = true;
  if (!root.classList.contains('is-live')) return;

  var html = document.documentElement;
  var scenes = [];
  var ticking = false;
  var vh = window.innerHeight;
  var scroller = null;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function smooth(t) { return t * t * (3 - 2 * t); }
  function setVar(el, k, v) { el.style.setProperty(k, v); }

  function findScroller() {
    var pw = document.querySelector('.page-wrapper');
    scroller = null;
    if (pw) {
      var o = window.getComputedStyle(pw).overflowY;
      if (o === 'auto' || o === 'scroll') scroller = pw;
    }
  }

  /* objects: hold each product in the centre, glide between them */
  function objectsK(p, n) {
    var seg = p * (n - 1 + 0.6) - 0.3;
    seg = clamp(seg, 0, n - 1);
    var i = Math.floor(seg), f = seg - i;
    if (i >= n - 1) return n - 1;
    return i + smooth(clamp((f - 0.28) / 0.44, 0, 1));
  }

  var chapter = root.querySelector('[data-ab-chapter]');
  var chNum = chapter && chapter.querySelector('[data-ab-ch-num]');
  var chName = chapter && chapter.querySelector('[data-ab-ch-name]');
  var lastCh = '';
  function showChapter(str) {
    if (!chapter || str === lastCh) return;
    lastCh = str;
    var parts = str.split('|');
    chNum.textContent = parts[0];
    chName.textContent = parts[1] || '';
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.target.__ab) en.target.__ab.on = en.isIntersecting; });
    request();
  }, { rootMargin: '25% 0px 25% 0px' });

  Array.prototype.forEach.call(root.querySelectorAll('[data-ab-scene]'), function (el) {
    var s = { el: el, kind: el.getAttribute('data-ab-scene'), on: false, pin: el.querySelector('.ab-pin') };
    if (s.kind === 'objects') s.items = Array.prototype.slice.call(el.querySelectorAll('.ab-obj'));
    if (s.kind === 'routines') {
      s.track = el.querySelector('[data-ab-track]');
      s.view = el.querySelector('.ab-routines__viewport');
      s.cards = Array.prototype.slice.call(el.querySelectorAll('.ab-scene'));
    }
    el.__ab = s;
    scenes.push(s);
    io.observe(el);
  });

  function frame() {
    ticking = false;
    var mid = vh * 0.5, chosen = null, anyOn = false;
    for (var i = 0; i < scenes.length; i++) {
      var s = scenes[i];
      if (!s.on) continue;
      anyOn = true;
      var r = s.el.getBoundingClientRect();
      var p;
      if (s.kind === 'final') {
        p = clamp((vh - r.top) / (vh + r.height), 0, 1);
        setVar(s.el, '--f', smooth(clamp((p - 0.05) / 0.4, 0, 1)).toFixed(4));
      } else {
        var ph = s.pin ? s.pin.offsetHeight : vh;
        var d = r.height - ph;
        p = d > 0 ? clamp(-r.top / d, 0, 1) : (r.top < 0 ? 1 : 0);
        setVar(s.el, '--p', p.toFixed(4));
        if (s.kind === 'objects') {
          var k = objectsK(p, s.items.length);
          setVar(s.el, '--k', k.toFixed(4));
          var on = Math.round(k);
          for (var j = 0; j < s.items.length; j++) s.items[j].classList.toggle('is-on', j === on);
        } else if (s.kind === 'routines' && s.track) {
          var span = s.track.scrollWidth - s.view.clientWidth;
          var t = smooth(clamp((p - 0.08) / 0.84, 0, 1));
          setVar(s.track, '--tx', (-Math.max(0, span) * t).toFixed(1) + 'px');
          var vw = s.view.clientWidth;
          for (var c = 0; c < s.cards.length; c++) {
            var cr = s.cards[c].getBoundingClientRect();
            var off = ((cr.left + cr.width / 2) - vw / 2) / vw;
            setVar(s.cards[c], '--sh', clamp(off, -1, 1).toFixed(3));
          }
        }
      }
      if (r.top <= mid && r.bottom > mid) {
        chosen = s.el.getAttribute('data-ab-ch');
        if (s.kind === 'intro' && p > 0.3) chosen = s.el.getAttribute('data-ab-ch2');
      }
    }
    if (chapter) {
      chapter.classList.toggle('is-on', anyOn && !!chosen);
      if (chosen) showChapter(chosen);
    }
  }

  function request() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(frame); }
  }

  findScroller();
  document.addEventListener('scroll', request, { passive: true, capture: true });
  window.addEventListener('resize', function () { vh = window.innerHeight; findScroller(); request(); }, { passive: true });
  window.addEventListener('load', request);
  request();

  /* reduced motion switched on while the page is open: fall back to the static story */
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var drop = function () { if (mq.matches) root.classList.remove('is-live'); };
  if (mq.addEventListener) mq.addEventListener('change', drop); else if (mq.addListener) mq.addListener(drop);
})();